import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_MAIN_URL || "http://localhost:3002";

const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

export default socket;
